import * as actionTypes from './actionTypes';
import axios from 'axios';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (tokenId, userId) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        tokenId: tokenId,
        userId: userId
    }
}

export const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("expiresIn");
    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout);
        }, expirationTime * 1000)
    }
}

export const authFail = (error) => {
    const errorMessage = setErrorMessage(error);
    return {
        type: actionTypes.AUTH_FAIL,
        error: errorMessage
    }
}

export const auth = (email, password, isSignUp) => {
    return dispatch => {
        dispatch(authStart());
        const authData = {
            email: email,
            password: password,
            returnSecureToken: true
        }
        let url = "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD5deo1vPrLJX6H9f8JeiZl8X-Ic4dYrOc";
        if(!isSignUp) {
            url = "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD5deo1vPrLJX6H9f8JeiZl8X-Ic4dYrOc";
        }
        axios.post(url, authData)
        .then(response => {
            localStorage.setItem("token", response.data.idToken);
            localStorage.setItem("userId", response.data.localId);
            const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
            localStorage.setItem("expiresIn", expirationDate);
            dispatch(authSuccess(response.data.idToken, response.data.localId));
            dispatch(checkAuthTimeout(response.data.expiresIn))
        })
        .catch(error => {
            dispatch(authFail(error.response.data.error.message));
        })
    }
}

export const checkAuthState = () => {
    return dispatch => {
        const token = localStorage.getItem("token");
        if(!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem("expiresIn"));
            if(expirationDate <= new Date()){
                dispatch(logout());
            } else {
                const userId = localStorage.getItem("userId");
                dispatch(authSuccess(token, userId));
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));
            }
            
        }

    }
}


export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

const setErrorMessage = error => {
    let message;

    switch(error){
        case 'INVALID_EMAIL':
            message = "Please enter valid email address";
            break;
        case 'EMAIL_NOT_FOUND':
            message = "User account does not exist";
            break;
        case 'INVALID_PASSWORD':
            message = "Password entered is invalid";
            break;
        case 'USER_DISABLED':
            message = "Your account has been disabled. Please contact admin";
            break;    
        case 'EMAIL_EXISTS':
            message = "Email already exists";
            break;
        case 'WEAK_PASSWORD':
            message = "Weak Password. Password should be atleast 6 characters";
            break;
        default:
            message = "Unknown error occured";
    }
    return message;
}